// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import SmartLockPage from './screens/SmartLockPage';
import PassDetailsPage from './screens/PassDetailsPage';
import { isMobile } from 'react-device-detect';
import { Container, Center, Text, Flex } from '@mantine/core';
import Lottie from 'lottie-react';
import WclogoAnimation from './assets/lottie/wclogo.json';
import errAnimation from './assets/lottie/error.json';
import { CONFIG } from './atoms/config';

function DesktopView() {
  return (
    <Container style={{ height: '100vh' }}>
      <Center style={{ height: '100%' }}>
        <div style={{ textAlign: 'center', justifyItems: 'center' }}>
          <Flex align="center" direction="column">
            <Lottie animationData={WclogoAnimation} style={{ width: 200, height: 200 }} loop={false} />
            <Text mt="md" size="lg" fw="bold">This feature is only available on Mobile</Text>
          </Flex>
        </div>
      </Center>
    </Container>
  );
}

function Four04({ message = 'The link you used is wrong, please try again with a valid link' }) {
  return (
    <Container style={{ height: '100vh' }}>
      <Center style={{ height: '100%' }}>
        <div style={{ textAlign: 'center', justifyItems: 'center', alignItems: 'center' }}>
          <Flex align="center" direction="column">
            <Lottie animationData={errAnimation} style={{ width: 200, height: 200 }} loop={false} />
            <Text mt="md" size="lg" fw="bold">{message}</Text>
          </Flex>
        </div>
      </Center>
    </Container>
  );
}

function AppRoutes() {
  if (!isMobile && !CONFIG.devMode && !CONFIG.devLocation) {
    return <DesktopView />;
  }
  return (
    <Routes>
      <Route path="/:siteID/:itemID" element={<SmartLockPage />} />
      <Route path="/passes/:siteID" element={<PassDetailsPage />} />
      <Route path="*" element={<Four04 />} />
    </Routes>
  );
}

export default function App() {
  return <AppRoutes />;
}
